/**
 * Procedure Categories and Procedures for DM in Neuroradiology students
 * Extracted with strict evidence from official NMC PDF (Page 8, 24: "Psychomotor Domain - perform independently")
 */
export const NEURORADIOLOGY_PROCEDURES = {
  "Diagnostic Neuro-Imaging & Ultrasound Procedures": [
    "Neurosonography, Transcranial Doppler (TCD) & Carotid Doppler",
    "Cranial & Spinal Computed Tomography (CT, Temporal Bone, Air Sinus, Orbit)",
    "Cranial & Spinal Magnetic Resonance Imaging (MRI, fMRI, Intra-operative MRI, MR Angiography)",
    "Water Soluble Myelography & CT Myelography",
    "Digital Subtraction Angiography (4-Vessel Cerebral Angiography, Spinal Angiography, Aortography)",
  ],
  "Interventional & Endovascular Neuroradiology Procedures": [
    "Thrombolysis & Mechanical Thrombectomy in Acute Ischemic Stroke",
    "Transarterial Particulate Embolization of Head, Neck & Spine Tumors",
    "Transarterial Liquid & Direct Puncture Embolization of Vascular Malformations (AVMs / AVFs)",
    "Percutaneous Transluminal Angioplasty (PTA) & Stenting of Intracranial & Extracranial Vessels",
    "Percutaneous Biopsy of Spinal & Cranio-Facial Pathologies",
    "Endovascular Aneurysm Coiling & Vascular Malformation Interventions",
  ],
};

export const NEURORADIOLOGY_CATEGORIES = Object.keys(NEURORADIOLOGY_PROCEDURES);

export const isDMInNeuroradiologyDept = (department) => {
  if (!department) {
    try {
      const u = JSON.parse(
        localStorage.getItem("userData") || localStorage.getItem("user") || "{}"
      );
      department = u.department || (u.departments && u.departments[0]);
    } catch (e) {}
  }
  if (!department) return false;
  const d = String(department).toLowerCase();
  return d.includes("neuroradiology") || d.includes("neuro-radiology") || d.includes("neuro radiology");
};
